import { render, staticRenderFns } from "./FavoriteDetail.vue?vue&type=template&id=1d4e3ee8&scoped=true"
import script from "./FavoriteDetail.vue?vue&type=script&lang=js"
export * from "./FavoriteDetail.vue?vue&type=script&lang=js"
import style0 from "./FavoriteDetail.vue?vue&type=style&index=0&id=1d4e3ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e3ee8",
  null
  
)

export default component.exports